/**
 * Arm the global crash handlers as the very first thing the bundle does.
 *
 * A side-effect module rather than a call in ``main.tsx``: ES modules evaluate
 * every import before the importing module's own body runs, so a handler
 * registered in that body is armed *too late* to catch a module that throws
 * while loading. That failure mode leaves a blank page with no error boundary,
 * no message and — until this file existed — no report either, which is a worse
 * version of the blind spot KAN-398 set out to close.
 *
 * Import this first in ``main.tsx``; it must stay first.
 */
import { initClientErrorReporting } from '@/lib/telemetry/client-error';

initClientErrorReporting();
